module.exports = __webpack_public_path__ + "img/icon-4.4d780e5e.png";